<template>
  <v-card>
    <v-card-title>
      <span class="title">{{titulo}}</span>
      <v-spacer></v-spacer>
      <v-btn
        small
        icon
        class="mr-3"
        v-if="puedoEditar()"
        @click="editar(item)"
      >
        <v-icon small>edit</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text v-if="editando">

      <v-dialog
        v-model="editando"
        persistent
        max-width="800px"
      >
        <v-card class="modal-principal">
          <v-card-title>{{titulo}}</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="max-height: 400px;overflow-y:auto;">
            <v-alert
              v-model="alerta.mostrar"
              dismissible
              :type="alerta.tipo"
            >
              {{alerta.mensaje}}
            </v-alert>
            <v-container grid-list-lg>
              <v-layout
                row
                wrap
              >
                <v-flex
                  xs12
                  sm6
                >
                  <v-text-field
                    v-model="edicion.item.email"
                    v-validate="'required|email|max:100'"
                    :error-messages="errors.collect('item.email')"
                    label="Email"
                    data-vv-name="item.email"
                    required
                    :disabled="soloLectura"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout
                row
                wrap
                v-if="!soloLectura"
              >
                <v-flex
                  xs12
                  sm6
                >
                  <v-text-field
                    ref="password"
                    label="Password"
                    v-model="edicion.item.password"
                    v-validate="validacion('password')"
                    :error-messages="errors.collect('password')"
                    data-vv-name="password"
                    autocomplete="false"
                    :append-icon="!hidePassword ? 'visibility' : 'visibility_off'"
                    @click:append="() => (hidePassword = !hidePassword)"
                    :type="hidePassword ? 'password' : 'text'"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  xs12
                  sm6
                >
                  <v-text-field
                    label="Confirmar password"
                    v-model="edicion.item.password_confirmation"
                    v-validate="validacion('password_confirmation')"
                    :error-messages="errors.collect('password_confirmation')"
                    data-vv-name="password_confirmation"
                    autocomplete="false"
                    :append-icon="!hidePassword2 ? 'visibility' : 'visibility_off'"
                    @click:append="() => (hidePassword2 = !hidePassword2)"
                    :type="hidePassword2 ? 'password' : 'text'"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout
                row
                wrap
                v-if="origen === 'abm'"
              >
                <v-flex xs12>
                  <v-select
                    v-model="edicion.item.roles_seleccionados"
                    :items="combos.roles"
                    :item-text="'name'"
                    :item-value="'id'"
                    label="Rol"
                    attach
                    chips
                    v-validate="'required'"
                    :error-messages="errors.collect('roles')"
                    data-vv-name="roles"
                    :disabled="soloLectura"
                  >

                  </v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <botones-cancelar-guardar
              v-bind:guardando="guardando"
              v-on:alGuardar="guardar"
              v-on:alCancelar="cerrar"
            ></botones-cancelar-guardar>

          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-text>
    <v-card-text>
      <v-layout
        row
        wrap
      >
        <v-flex v-bind="colDetalle">
          <dt>Email</dt>
          <dd>{{item.email}}</dd>
        </v-flex>

        <v-flex v-bind="colDetalle">
          <dt>Rol</dt>
          <dd>
            <v-chip
              small
              color="blue-gray"
              v-for="(rol,key) in rolesFormateados(item.roles)"
              :key="key"
            >{{ rol }}</v-chip>
          </dd>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import _ from 'lodash'
import mixinseccionModulo from '@/mixins/seccionModulo'
import Combo from '@/api/combo'
export default {
  name: 'VUsuarioDatosBasicos',
  props: {
    origen: {
      type: String,
      required: true
    }
  },

  mixins: [mixinseccionModulo],
  computed: {
    item () {
      return _.pick(this.$store.getters['detalleUsuario/usuarioSeleccionado'], ['id', 'usuario', 'email', 'roles', 'roles_seleccionados'])
    }
  },
  data () {
    return {
      moduloStore: 'detalleUsuario',
      titulo: 'Datos de usuario',
      seccion: 'general',
      hidePassword: true,
      hidePassword2: true
    }
  },
  methods: {
    prepararEdicion () {
      let vm = this

      let dataCombos = {
        roles: null
      }
      this.edicion.item.roles_seleccionados = _.map(this.edicion.item.roles, (rol) => {
        return rol.id
      })
      this.edicion.item.roles_seleccionados = this.edicion.item.roles_seleccionados[0]

      return Combo.listado(dataCombos).then(
        data => {
          vm.llenarCombos(data)
          vm.cargando = false
          Promise.resolve()
        },
        error => {
          vm.mostrarError(error)
          vm.soloLectura = true
          vm.cargando = false
          Promise.reject(error)
        }
      )
    },
    rolesFormateados (roles) {
      return _.map(roles, item => {
        return item.name
      })
    },
    validacion (campo) {
      let validar = ''
      switch (campo) {
        case 'password':
          validar = 'min:6|max:20'
          break
        case 'password_confirmation':
          validar = (this.edicion.item.password ? 'required|' : '') + 'confirmed:password'
          break
        default:
          validar = ''
          break
      }
      return validar
    }
  }

}
</script>

<style lang="scss" scoped>
</style>
